(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {

    $('.faq_cat').click(function (e) {
      e.preventDefault();
      var faq_cat = $(this).data('faq');
      console.log(faq_cat);
      $('.faq_cat').each(function (i) {
        $(this).removeClass('selected');
      });
      $(this).addClass('selected');
      $('.faq_category').each(function (i) {
        $(this).hide();
      });

      $(faq_cat).fadeIn(800);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-tabbed"] && !Shopify.designMode) return;
  try {
    
  var radioArray = document.querySelectorAll('.tabs input[type="radio"]');
  for (let k=0; k<radioArray.length; k++) {
    radioArray[k].addEventListener('change', function () {
      document.querySelectorAll('.tab__content').forEach(el => {
        el.classList.remove('active');
      });
      
      document.getElementById('tabCollections').className = '';
      document.getElementById('tab__content--' + this.dataset.tab).classList.add('active');
      document.getElementById('tabCollections').classList.add('tab-' + this.dataset.tab);
      document.getElementById('tabCollections').classList.add('tab_collections');
      document.getElementById('tabCollections').classList.add('page_width');
      document.getElementById('tabCollections').classList.add('flicking-camera');
    });

    $(window).on('load resize orientationchange', function() {
        //$('.tab_collections').each(function(){
            const $carousel = $('.tab_collections');
            $carousel.on('reInit', function (event,slick,currentSlide) {
                  console.log(currentSlide);
                });
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 900) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                dots:true,
                arrows:false,
                infinite:false,
                });

                

                    $carousel.on('afterChange',function (event,slick,currentSlide) {
                      document.querySelectorAll('.tab__content').forEach(el => {
                        el.classList.remove('active');
                      });
                      document.getElementById('tab__content--' + (currentSlide+1)).classList.add('active');
                      document.getElementById('tabCollections').className = '';
                      document.getElementById('tabCollections').classList.add('tab-' + (currentSlide+1));
                      document.getElementById('tabCollections').classList.add('tab_collections');
                      document.getElementById('tabCollections').classList.add('page_width');
                      document.getElementById('tabCollections').classList.add('flicking-camera');
                    });
                }
            }
        //});
    });
    
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
